import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMutate } from "src/hooks/useFetch.hook";
import { getProductCatalogUrlId } from "src/react-query/endPoints";
import { useCallback, useMemo } from "react";
export const ProductActionMenu = ({ productId }) => {
  const { mutate } = useMutate("users");
  const onDelete = useCallback(() => {
    mutate(
      { url: getProductCatalogUrlId(productId), method: "DELETE" },
      {
        onSuccess: () => {
          window.location.reload(); // refresh the page
        },
      }
  );
  }, [productId, mutate]);
  const actionList = useMemo(
    () => [
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        routerLink: `${productId}`,
      },
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: onDelete,
      },
    ],
    [productId, onDelete]
  );

  return <ActionsMenu menuList={actionList} />;
};
